import Vue from 'vue'
import VueRouter from 'vue-router'
import AdminLogin from '../views/AdminLogin.vue'
import AdminDashboard from '../views/AdminDashboard.vue'
import WebsiteDashboard from '../views/WebsiteDashboard.vue'
import WebsiteNewsAdmin from '../views/WebsiteNewsAdmin.vue'
import WebsiteVersionsAdmin from '../views/WebsiteVersionsAdmin.vue'
import ArticleAdmin from '../views/ArticleAdmin.vue'
import NotFound from '../views/NotFound.vue'

Vue.use(VueRouter)

const routes = [
  {
    path: '/',
    redirect: '/yuanhui66-login'
  },
  {
    path: '/yuanhui66-login',
    name: 'AdminLogin',
    component: AdminLogin
  },
  // 管理后台路由
  {
    path: '/adminyuanhui66',
    component: AdminDashboard,
    meta: { requiresAuth: true },
    children: [
      {
        path: '',
        redirect: '/adminyuanhui66/dashboard'
      },
      {
        path: 'dashboard',
        name: 'AdminDashboard',
        component: WebsiteDashboard
      },
      {
        path: 'news',
        name: 'WebsiteNewsAdmin',
        component: WebsiteNewsAdmin
      },
      {
        path: 'versions',
        name: 'WebsiteVersionsAdmin',
        component: WebsiteVersionsAdmin
      },
      {
        path: 'articles',
        name: 'ArticleAdmin',
        component: ArticleAdmin
      }
    ]
  },
  {
    path: '*',
    name: 'NotFound',
    component: NotFound
  }
]

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes
})

// 路由守卫
router.beforeEach((to, from, next) => {
  // 检查是否需要登录
  if (to.matched.some(record => record.meta.requiresAuth)) {
    const adminToken = localStorage.getItem('adminToken');
    
    if (!adminToken) {
      // 没有登录，跳转到登录页
      next('/yuanhui66-login');
    } else {
      // 已登录，继续访问
      next();
    }
  } else {
    // 不需要登录的页面，直接访问
    next();
  }
});

// 全局路由错误处理
const originalPush = router.push;
router.push = function push(location) {
  return originalPush.call(this, location).catch(err => {
    if (err.name !== 'NavigationDuplicated') {
      throw err;
    }
  });
};

export default router 